import React from 'react'
import PropTypes from 'prop-types'

const MusicIcon = props => {
    const { width, height} = props
    return(
<svg className="icon" width={width} height={height} viewBox="0 0 22 24" version="1.1" xmlns="http://www.w3.org/2000/svg"  >

    <g id="Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-224.000000, -156.000000)" fill="#979797" id="Fill-1">
            <path d="M245.849963,156.10856 C245.754925,156.025918 245.629527,155.988314 245.50325,156.003181 L231.863083,157.75703 C231.643527,157.785452 231.47941,157.97085 231.47941,158.190792 L231.47941,160.821784 L231.47941,162.663522 L231.47941,174.047582 C230.715586,173.177435 229.52365,172.615556 228.179916,172.615556 C225.871283,172.615556 224,174.268835 224,176.307778 C224,178.346721 225.871283,180 228.179916,180 C230.48855,180 232.359833,178.346721 232.359833,176.307778 C232.359833,176.162608 232.347953,176.020061 232.329473,175.878826 C232.347513,175.831602 232.359833,175.782192 232.359833,175.729283 L232.359833,163.047436 L245.120018,161.4064 L245.120018,169.674546 C244.355313,168.804837 243.163377,168.242958 241.820084,168.242958 C239.51145,168.242958 237.640167,169.896237 237.640167,171.93518 C237.640167,173.974122 239.51145,175.627402 241.820084,175.627402 C244.128717,175.627402 246,173.974122 246,171.93518 C246,171.894952 245.99428,171.856036 245.99296,171.816245 C245.99384,171.804439 246,171.794819 246,171.782576 L246,160.908799 L246,159.067498 L246,156.436942 C246,156.311012 245.945441,156.191202 245.849963,156.10856"></path>
        </g>
    </g>
</svg>
)}


MusicIcon.defaultProps = {
    width: 24,
    height: 24
}

MusicIcon.prototype = {
    width: PropTypes.string,
    height: PropTypes.string
}
export default MusicIcon;